export default function Picfetchh(id, callback) {
  fetch(`https://dandeline.tongji.edu.cn/api/get_photo`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      "agentId": "200027",
      "agentSecret": "QE_pa9KHh84YbAMbhs0PcthBoWtrBA7QNY00Qz67RaI",
      "teacher_id": id
    })
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      callback(`data:image/png;base64,${data.base64}`);
    })
    .catch(error => {
      console.error('Fetching error:', error);
      fetch(`https://dandeline.tongji.edu.cn/api/model`)
        .then(response => {
          if (!response.ok) {
            throw new Error('Model image response was not ok');
          }
          return response.blob();
        })
        .then(modelImage => {
          const objectURL = URL.createObjectURL(modelImage);
          callback(objectURL);
        })
        .catch(secondError => {
          console.error('Error fetching model image:', secondError);
          callback(null);
        });
    });
}